import { render, staticRenderFns } from "./SignaturesProvider.vue?vue&type=template&id=10b5d590&scoped=true"
import script from "./SignaturesProvider.vue?vue&type=script&lang=js"
export * from "./SignaturesProvider.vue?vue&type=script&lang=js"
import style0 from "./SignaturesProvider.vue?vue&type=style&index=0&id=10b5d590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5d590",
  null
  
)

export default component.exports